import React, { Component } from 'react';
import StyleSheet from 'stilr';
import Alarm from '@mui/icons-material/SentimentVerySatisfied';
import i18n from 'app/common/i18n';

const styles = new StyleSheet.create({
  wrapper: {
    maxWidth: 600,
    margin: 'auto',
    padding: '40px 15px 0',
    textAlign: 'center'
  }
});

class NotFound extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <h2>{this.props.i18n('Something bad happened')}</h2>
        <h4>{this.props.i18n('But we still love you')}</h4>
        <h5>
          {this.props.i18n('Please try again or contact customer support')}
        </h5>
        <Alarm style={{ height: 100, width: 100, textAlign: 'center' }} />
      </div>
    );
  }
}

export default i18n(NotFound);